import './receipt-list.scss';

import { some, pull } from 'lodash';

import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { FocusStream } from '@pos/app/scripts/services/focus-streams';
import { PosUiState } from '@pos/app/scripts/services/pos-ui-state';
import { SettingsManager } from '@shared/app/scripts/services/settings-manager';
import { Utility } from '@core/app/scripts/services/utility';
import { FashionCheque } from '@shared/app/scripts/services/fashion-cheque';

/*
 * receipt-list component.
 */
angular
  .module('posApp')
  .directive(
    'receiptList',
    (
      focusStreams: FocusStream,
      fashionCheque: FashionCheque,
      loadArticleInfo,
      navigateTo: NavigateTo,
      pos,
      posUiState: PosUiState,
      settingsManager: SettingsManager,
      utility: Utility,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./receipt-list.html').default,

      link: function ($scope, element, attrs) {
        $scope.displayDiscountReason =
          settingsManager.settings.displayAndPrintDiscountReason;

        $scope.isActiveLine = (index) => {
          if (!posUiState.multiLine) {
            return index === posUiState.selectedLine;
          }

          return some(posUiState.selected, pos.transaction.receipt[index]);
        };

        $scope.isFashionChequeCoupon = function (item) {
          return item.couponNr ? fashionCheque.validateCode(item.couponNr) : '';
        };

        $scope.getMaskedCouponNr = function (item) {
          return item.couponNr ? item.couponNr.replace(/\d{4}$/, '****') : '';
        };

        $scope.selectCurrentLine = (currentLine) => {
          const receipt = pos.transaction.receipt;
          //Price button is active
          if (posUiState.multiLine) {
            if (receipt[currentLine].category == 'barcode') {
              if (some(posUiState.selected, receipt[currentLine])) {
                posUiState.selected = pull(
                  posUiState.selected,
                  receipt[currentLine],
                );
              } else {
                posUiState.selected.push(receipt[currentLine]);
              }

              posUiState.dialog.inputValue = 0;

              const list = posUiState.selected;
              for (let i = 0; i < list.length; i++) {
                posUiState.dialog.inputValue +=
                  list[i].price * Math.abs(list[i].qty);
              }
              posUiState.dialog.inputValue = String(
                utility.round2(posUiState.dialog.inputValue),
              );
              const dot = posUiState.dialog.inputValue.indexOf('.');

              if (dot == -1) {
                posUiState.dialog.inputValue += '.00';
              } else if (dot == posUiState.dialog.inputValue.length - 2) {
                posUiState.dialog.inputValue += '0';
              }
            } else {
              //flip mode
              posUiState.multiLine = false;
            }
          } else {
            if (posUiState.dialogCallback == 'changePrice') {
              if (receipt[currentLine].category == 'barcode') {
                posUiState.multiLine = true;
                posUiState.selected = [receipt[currentLine]];
              }
            }
          }
          posUiState.selectedLine = currentLine;

          if (posUiState.dialogCallback) {
            focusStreams.inputSubject.next(undefined);
          } else {
            focusStreams.searchSubject.next(undefined);
          }
        };

        $scope.showArticleInfo = (index, item) => {
          if (item.category == 'barcode') {
            // TODO replace by ref in article-info/ when works as expected
            loadArticleInfo('pos.route#pos');

            navigateTo(`pos.route#article-info/${item.barcode}`);
          }
        };
      },
    }),
  );
